import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Header.css';

const Header = ({ onLeaveCompetition, inCompetition }) => {
  const { currentLanguage, setLanguage, t, availableLanguages, platformName, logoUrl } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  const handleLeave = () => {
    if (window.confirm(t('leaveCompetition') + '?')) {
      onLeaveCompetition();
      navigate('/');
    }
  };

  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={() => navigate('/')}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={platformName}
              className="logo-image"
              onError={(e) => {
                e.target.style.display = 'none';
                const fallback = e.target.nextElementSibling;
                if (fallback) fallback.style.display = 'inline';
              }}
            />
          ) : null}
          <span className="logo-text" style={{ display: logoUrl ? 'none' : 'inline' }}>
            {platformName}
          </span>
        </div>
        
        <nav className="header-nav">
          {!inCompetition && (
            <button
              className="nav-button"
              onClick={() => navigate('/scoreboard')}
            >
              {t('scoreboard')}
            </button>
          )}
          
          {!isAdminPage && !inCompetition && (
            <button
              className="nav-button"
              onClick={() => navigate('/')}
            >
              {t('join')}
            </button>
          )}

          {inCompetition && (
            <button
              className="nav-button leave-button"
              onClick={handleLeave}
            >
              {t('leaveCompetition')}
            </button>
          )}

          <div className="language-selector">
            <select
              className="language-select"
              value={currentLanguage}
              onChange={(e) => handleLanguageChange(e.target.value)}
            >
              <option value="auto">{t('auto')}</option>
              {availableLanguages.map((lang) => (
                <option key={lang.shortcut} value={lang.shortcut}>
                  {lang.shortcut.toUpperCase()} - {lang.name}
                </option>
              ))}
            </select>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
